<template>
	<div id="signUpInfo">
		<Loading v-if="show"></Loading>
		<div class="signUpInfo_container">
			<div class="nav" v-if="navShow">
				<a :href="navhomeUrl" target="_top">首页</a>
				> <a>日程预览</a>
			</div>
			<div class="banner-img" v-if="meetingInfo.MobileBannerImage!=null&&red!='im'">
				<img :src="meetingInfo.MobileBannerImage">
			</div>
			<div class="signUpInfo_content">
				<div id="meeting_info" class="commonW">
					<div class="search">
						<input type="text" placeholder="输入关键字" class="search-inp" v-model="searchKeyword" />
						<div class="search-btn" @click="search()">
							<van-icon name="search" />
						</div>
					</div>
					<div v-if="previewData!=null && previewData.length>0">
						<div class="preview-date">
							<div class="date-list" v-for="(item,index) in previewData" :key='index'
								:class="{'active':active==index}" @click="changeDate($event,index)">
								<p class="mon">{{item.ProDate.split('-')[0]}}月</p>
								<p class="day">{{item.ProDate.split('-')[1]}}</p>
							</div>
						</div>
						<div class="preview-info" v-for="(items,indexs) in previewDataList" :key='indexs'>
							<div class="preview-room" :style="{ backgroundColor: detailBg }">
								{{items.ProRoomName}}
							</div>
							<div class="preview-con">
								<div class="preview-con-scroll" :style="{width: items.scrollWidth + '%' }">
									<div class="preview-detail" v-for="(itemss,indexss) in items.Details" :key='indexss'
										:style="{borderColor: detailBg}">
										<a v-bind:href="['#/meeting/scheduleList?m='+params.m+'&roomid='+itemss.RoomId+'&dateid='+itemss.DateId+'&top='+itemss.ProId+'']"
											target="_top">
											<div class="preview-time" :style="{ backgroundColor: detailBg }">
												<van-cell icon="underway-o" :value="itemss.StartEndTimes"
													class="forumDate-time" :style="{ backgroundColor: detailBg }" />
											</div>
											<div class="preview-title">
												{{itemss.ProTitle}}
											</div>
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="noDate" v-else>
						暂无日程信息
					</div>
				</div>
				<div class="loading" v-if="loading">
					<van-loading type="spinner" color="#1989fa" vertical size="30px" text-size="14px">加载中...
					</van-loading>
				</div>
			</div>
		</div>
		<Footer v-if="footerShow" :footInfo="this.footInfo"></Footer>
		<Nav v-if="fNavShow"></Nav>
	</div>
</template>
<script>
	import Loading from '@components/Loading.vue'
	import Footer from '@components/Footer.vue'
	import Nav from './../SignUp/components/navigation.vue'
	import publicSignup from '../../lib/signUp.js'
	import wxShare from '../../lib/wxShare.js'
	export default {
		name: 'previewInfo',
		components: {
			Footer,
			Nav,
			Loading,
		},
		data() {
			return {
				publicSignup: {}, //通用js
				params: {
					m: '',
					red: '',
				},
				meetingInfo: '',
				show: false,
				loading: false,
				previewData: [],
				previewDataList: [],
				active: 0,
				red: '',
				navShow: true,
				navhomeUrl: '',
				searchKeyword: '',
				detailBg: '',
				footerShow: true,
				fNavShow: true,
				footInfo: {
					LogoTxt: '',
					LogoLink: '',
					LogoImg: '',
				},
			}
		},
		created() {
			this.params = this.$route.query
			this.red = this.params.red
			this.publicSignup = new publicSignup()
			console.log(this.publicSignup)
			let opt = {
				m: this.params.m
			}
			this.initmeeting(opt)
			this.previewGet(opt)
			this.init()
		},
		mounted() {
			//this.swiperInit()
		},
		methods: {
			async init() {
				if (this.$route.path === '/signup/meetingsignup') {
					this.fNavShow = false
				} else {
					this.fNavShow = true
				}
				console.log(this.$route.path)
			},
			async initmeeting(opt) {
				this.show = true
				this.meetingInfo = await this.publicSignup.init(opt, this)
				if (this.meetingInfo.Code === 1000) {
					this.show = false
					this.footInfo.LogoTxt = this.meetingInfo.LogoTxt
					this.footInfo.LogoLink = this.meetingInfo.LogoLink
					this.footInfo.LogoImg = this.meetingInfo.LogoImg
					if (this.meetingInfo.HomeUrl == null || this.meetingInfo.HomeUrl == '') {
						this.navShow = false
					} else {
						this.navShow = true
						this.navhomeUrl = this.meetingInfo.HomeUrl
					}
					if (this.meetingInfo.isshowlogo == 1) {
						this.footerShow = false
					} else {
						this.footerShow = true
					}
				} else {
					this.$notify({
						massage: this.meetingInfo.Msg,
						type: 'danger',
						duration: '3000',
					})
				}
			},
			/**
			 * 日程一览数据
			 */
			async previewGet(opt) {
				try {
					this.loading = true
					let res = await this.$http.previewmeeting(opt)
					console.log(res)
					this.loading = false
					this.previewData = res.Dates
					this.previewData = this.previewData
					let roomList = this.previewData[this.active].Rooms
					this.changeColor(this.active)
					for (let i in roomList) {
						this.previewDataList.push({
							ProRoomName: roomList[i].ProRoomName,
							Details: roomList[i].Details,
							scrollWidth: 100
						})
						this.previewDataList[i].scrollWidth = roomList[i].Details.length / 2 * 100
					}
				} catch (err) {
					console.log(err)
				}
			},
			changeColor(index) {
				if (index % 9 == 0) {
					this.detailBg = '#2196f3'
				} else if (index % 9 == 1) {
					this.detailBg = '#00bcd4'
				} else if (index % 9 == 2) {
					this.detailBg = '#009688'
				} else if (index % 9 == 3) {
					this.detailBg = '#3f51b5'
				} else if (index % 9 == 4) {
					this.detailBg = '#4caf50'
				} else if (index % 9 == 5) {
					this.detailBg = '#ff9800'
				} else if (index % 9 == 6) {
					this.detailBg = '#673ab7'
				} else if (index % 9 == 7) {
					this.detailBg = '#ffc107'
				} else if (index % 9 == 8) {
					this.detailBg = '#cddc39'
				}
			},
			changeDate(e, index) {
				this.active = index
				this.changeColor(index)
				this.previewDataList = []
				let roomList = this.previewData[this.active].Rooms
				for (let i in roomList) {
					this.previewDataList.push({
						ProRoomName: roomList[i].ProRoomName,
						Details: roomList[i].Details,
						scrollWidth: 100
					})
					this.previewDataList[i].scrollWidth = roomList[i].Details.length / 2 * 100
				}
			},

			goDetail(e, roomid, dateid) {
				const params = {
					roomid: roomid,
					dateid: dateid,
				}
				const {
					m
				} = this.$route.query
				this.$router.push({
					path: '/meeting/scheduleList',
					query: {
						m,
						...params
					},
				})
			},

			search() {
				const m = this.params.m
				if (this.searchKeyword !== '') {
					let search = this.searchKeyword
					this.$router.push({
						path: '/meeting/searchList',
						query: {
							m,
							search
						},
					})
				} else {
					this.$router.push({
						path: '/meeting/place',
						query: {
							m
						},
					})
				}
			},

			//微信分享
			async initShare(title, desc, link, imgUrl) {
				try {
					const headRes = await this.$http.csData({
						url: encodeURIComponent(
							window.location.href.replace(location.hash, '')
						),
					})
					console.log(headRes, 'headRes')
					const _Wx = new wxShare({
						opt: headRes,
					})
					_Wx.ready().then((wx) => {
						_Wx.share(title, desc, link, imgUrl)
						console.log(wx)
					})
					//this.headRess = _Wx
				} catch (err) {
					console.log(err)
				}
			},
		},
	}
</script>
<style lang="scss">
	.payDialog {
		.van-dialog__message {
			font-size: 32px;
			height: 100px;
			line-height: 100px;
		}

		.van-button {
			height: 100px;
			line-height: 100px;
		}

		.van-button__text {
			font-size: 32px;
		}

	}

	.swiper-pagination-bullet {
		width: 14px !important;
		height: 14px !important;
	}
</style>
<style lang="scss" scoped>
	.commonW {
		width: 100%;
		margin: 0 auto;
	}

	// ----------
	#signUpInfo {
		.signUpInfo_container {
			padding-bottom: 100px;


			.note {
				text-align: center;
				font-size: 22px;
				color: #999;
				margin-top: 20px;
			}
		}

		.van-dialog {
			width: 70%;
			text-align: center;
			font-size: 32px;
			padding-top: 20px;

			.van-dialog__content {
				margin: 20px;
			}

			.van-button {
				font-size: 32px;
				line-height: 60px;
				height: 60px;
			}
		}
	}

	.search {
		width: 100%;
		padding: 10px;
		box-sizing: border-box;
		display: flex;

		.search-inp {
			border-radius: 0;
			flex: 1;
			height: 74px;
			font-size: 28px;
			padding: 0 20px;
			border: 1px solid #ccc;
			background: #fff;
			border-radius: 42px 0 0 42px;
		}

		.search-btn {
			width: 78px;
			height: 74px;
			background: #289adc;
			text-align: center;
			border-radius: 0 42px 42px 0;

			.van-icon {
				color: #fff;
				font-size: 28px;
				padding-top: 24px;
			}
		}

		.language {
			font-size: 28px;
			text-align: center;
			line-height: 40px;
			margin: 20px;
		}
	}

	.preview-date {
		display: flex;
		justify-content: center;
		padding: 15px 0 5px;
		background: #fff;
		flex-wrap: wrap;
		margin-bottom: 20px;
	}

	.date-list {
		font-size: 26px;
		text-align: center;
		border: 1px solid #dbdee0;
		color: #7d7d7d;
		margin: 0 5px 10px;
		border-radius: 10px;
		overflow: hidden;
	}

	.date-list p {
		padding: 0 10px;
	}

	.date-list p.mon {
		font-weight: bold;
	}

	.date-list p.day {
		background: #dbdee0;
		color: #292929;
	}


	.date-list:nth-child(9n+1) {
		color: rgb(33, 150, 243);
		border: 1px solid rgb(33, 150, 243);
	}

	.date-list:nth-child(9n+1) p.day {
		color: #fff;
		background: rgb(33, 150, 243);
	}

	.date-list:nth-child(9n+1).active {
		color: #fff;
		background: rgb(33, 150, 243);
	}

	.date-list:nth-child(9n+1).active p.day {
		background: #fff;
		color: rgb(33, 150, 243);
	}


	.date-list:nth-child(9n+2) {
		color: rgb(0, 188, 212);
		border: 1px solid rgb(0, 188, 212);
	}

	.date-list:nth-child(9n+2) p.day {
		color: #fff;
		background: rgb(0, 188, 212);
	}

	.date-list:nth-child(9n+2).active {
		color: #fff;
		background: rgb(0, 188, 212);
	}

	.date-list:nth-child(9n+2).active p.day {
		background: #fff;
		color: rgb(0, 188, 212);
	}


	.date-list:nth-child(9n+3) {
		color: rgb(0, 150, 136);
		border: 1px solid rgb(0, 150, 136);
	}

	.date-list:nth-child(9n+3) p.day {
		color: #fff;
		background: rgb(0, 150, 136);
	}

	.date-list:nth-child(9n+3).active {
		color: #fff;
		background: rgb(0, 150, 136);
	}

	.date-list:nth-child(9n+3).active p.day {
		background: #fff;
		color: rgb(0, 150, 136);
	}


	.date-list:nth-child(9n+4) {
		color: rgb(63, 81, 181);
		border: 1px solid rgb(63, 81, 181);
	}

	.date-list:nth-child(9n+4) p.day {
		color: #fff;
		background: rgb(63, 81, 181);
	}

	.date-list:nth-child(9n+4).active {
		color: #fff;
		background: rgb(63, 81, 181);
	}

	.date-list:nth-child(9n+4).active p.day {
		background: #fff;
		color: rgb(63, 81, 181);
	}


	.date-list:nth-child(9n+5) {
		color: rgb(76, 175, 80);
		border: 1px solid rgb(76, 175, 80);
	}

	.date-list:nth-child(9n+5) p.day {
		color: #fff;
		background: rgb(76, 175, 80);
	}

	.date-list:nth-child(9n+5).active {
		color: #fff;
		background: rgb(76, 175, 80);
	}

	.date-list:nth-child(9n+5).active p.day {
		background: #fff;
		color: rgb(76, 175, 80);
	}

	.date-list:nth-child(9n+6) {
		color: rgb(255, 152, 0);
		border: 1px solid rgb(255, 152, 0);
	}

	.date-list:nth-child(9n+6) p.day {
		color: #fff;
		background: rgb(255, 152, 0);
	}

	.date-list:nth-child(9n+6).active {
		color: #fff;
		background: rgb(255, 152, 0);
	}

	.date-list:nth-child(9n+6).active p.day {
		background: #fff;
		color: rgb(255, 152, 0);
	}

	.date-list:nth-child(9n+7) {
		color: rgb(103, 58, 183);
		border: 1px solid rgb(103, 58, 183);
	}

	.date-list:nth-child(9n+7) p.day {
		color: #fff;
		background: rgb(103, 58, 183);
	}

	.date-list:nth-child(9n+7).active {
		color: #fff;
		background: rgb(103, 58, 183);
	}

	.date-list:nth-child(9n+7).active p.day {
		background: #fff;
		color: rgb(103, 58, 183);
	}

	.date-list:nth-child(9n+8) {
		color: rgb(255, 193, 7);
		border: 1px solid rgb(255, 193, 7);
	}

	.date-list:nth-child(9n+8) p.day {
		color: #fff;
		background: rgb(255, 193, 7);
	}

	.date-list:nth-child(9n+8).active {
		color: #fff;
		background: rgb(255, 193, 7);
	}

	.date-list:nth-child(9n+8).active p.day {
		background: #fff;
		color: rgb(255, 193, 7);
	}

	.date-list:nth-child(9n+9) {
		color: rgb(205, 220, 57);
		border: 1px solid rgb(205, 220, 57);
	}

	.date-list:nth-child(9n+9) p.day {
		color: #fff;
		background: rgb(205, 220, 57);
	}

	.date-list:nth-child(9n+9).active {
		color: #fff;
		background: rgb(205, 220, 57);
	}

	.date-list:nth-child(9n+9).active p.day {
		background: #fff;
		color: rgb(205, 220, 57);
	}



	.preview-info {
		padding: 0 20px;
		display: flex;
		font-size: 26px;
	}

	.preview-room {
		width: 110px;
		background-color: #289adc;
		display: flex;
		color: #fff;
		align-items: center;
		justify-content: center;
		font-size: 26px;
		padding: 20px 10px;
		border-radius: 10px;
		text-align: center;
		margin-bottom: 20px;
	}

	.preview-con {
		flex: 1;
		overflow-x: auto;
	}

	.preview-con-scroll {
		width: 200%;
		height: 100%;
	}

	.preview-detail {
		width: 260px;
		float: left;
		margin-left: 20px;
		border: 5px solid #289adc;
		border-radius: 10px;
		text-align: center;
		margin-bottom: 20px;
		height: calc(100% - 30px);
		background-color: #e7f3fc;
		box-shadow: 0 0 10px rgba(0, 0, 0, .8);

		a {
			color: #333;
			display: block;
			width: 100%;
			height: 100%;
		}
	}

	.preview-time {
		background: #289adc;
		padding: 5px 0;
		color: #fff;

		.van-cell {
			background: #289adc;
			color: #fff;
			text-align: center;
			justify-content: center;
			font-size: 26px;
			font-weight: bold;

			.van-cell__left-icon {
				font-size: 26px;
			}

			.van-cell__value--alone {
				color: #fff;
			}
		}
	}

	.preview-title {
		padding: 10px;
		height: 150px;
		overflow: hidden;
	}

	.nav {
		height: 76px;
		font-size: 26px;
		line-height: 76px;
		background: #289adc url(../../assets/home.png) no-repeat 20px center;
		background-size: 30px 30px;
		color: #fff;
		padding: 0 30px 0 60px;

		a {
			color: #fff;
		}
	}

	.banner-img img {
		width: 100%;
	}

	#foot {
		position: absolute;
		width: 100%;
		height: 50px;
		text-align: center;
		bottom: 0;
		border-top: 1px solid #e6e6e6;
		background: #f5f5f5;
		padding: 10px;
		color: #999;
		line-height: 50px;
		margin: 0 auto;
	}

	#foot img {
		display: inline-block;
		vertical-align: top;
		height: 50px;
		margin-right: 10px;
	}
</style>
